import React from 'react';
import TextNode from '../TextNode';
import ProgressBar from '../ProgressBar';

const TreeItem = (props: any) => {
  const { dataConfig } = props || {};
  const { topDataConfig, bottomDataConfig } = dataConfig;

  return (
    <div className='dbd-tree-box-item'>
      <TextNode dataConfig={topDataConfig}/>
      <ProgressBar dataConfig={bottomDataConfig}/>
    </div>
  );
};

export default TreeItem;